<template>
    <div class="paddingLeftRight">
        <div class="slider">
            <el-slider v-model="lrConfig.val" :max="1000" @change="updataRenderer"></el-slider>
        </div>
        <div class="input">
            <el-input v-model="lrConfig.val" size="small" @input="updataRenderer"></el-input>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return{
            val:0,  
        }
    },
    props:{
        lrConfig:{
            type: Object,
            default: {}
        }
    },
    created() {
        this.lrConfig.val = Number(this.lrConfig.val)
    },
    methods:{
        updataRenderer(val){
            this.lrConfig.val = Number(val)
        }
    }
}
</script>

<style scoped lang="scss">
    .paddingLeftRight{
        width: 100%;
        height: 38px;
        margin: 10px 0;
        display: flex;
        align-items: center;
        .slider{
            flex: 1;
        }
        .input{
            flex: 1;
            margin-left: 10px;
        }
    }
</style>